import { render, staticRenderFns } from "./DocumentsAndAtasTab.vue?vue&type=template&id=0ded9e90&scoped=true"
import script from "./DocumentsAndAtasTab.vue?vue&type=script&lang=js"
export * from "./DocumentsAndAtasTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentsAndAtasTab.vue?vue&type=style&index=0&id=0ded9e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded9e90",
  null
  
)

export default component.exports